
import { defineComponent, ref } from "vue";
import { footerWidthFluid } from "@/core/helpers/config";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import router from "@/router";
import axios from "axios";

export default defineComponent({
  name: "KTFooter",
  setup() {
    const certNo = ref("");

    const searchCertificate = async () => {
      if (!certNo.value.trim()) {
        Swal.fire({
          text: "กรุณากรอกเลขที่ใบรับรอง",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "ตกลง",
          customClass: {
            confirmButton: "btn fw-semibold btn-light-warning",
          },
        });
        return;
      }

      try {
        const headers = { token: localStorage.getItem("id_token") };
        const params = "?certificateNumber=" + certNo.value.trim();

        const [courseRes, syllabusRes] = await Promise.allSettled([
          axios.get(process.env.VUE_APP_API_URL + "/getCourseCertificate" + params, { headers }),
          axios.get(process.env.VUE_APP_API_URL + "/getSyllabusCertificate" + params, { headers }),
        ]);

        const courseData =
          courseRes.status === "fulfilled" && courseRes.value.data?.code === 200 && courseRes.value.data.data.content.length > 0
            ? courseRes.value.data.data.content
            : null;
        const syllabusData =
          syllabusRes.status === "fulfilled" && syllabusRes.value.data?.code === 200 && syllabusRes.value.data.data.content.length > 0
            ? syllabusRes.value.data.data.content
            : null;

        if (courseData && courseData.length > 0 || syllabusData && syllabusData.length > 0) {
          Swal.fire({
            text: "พบใบรับรองเลขที่ " + certNo.value,
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "ตกลง",
            customClass: {
              confirmButton: "btn fw-semibold btn-light-success",
            },
          });
        } else {
          Swal.fire({
            text: "ไม่พบใบรับรองเลขที่ " + certNo.value,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "ตกลง",
            customClass: {
              confirmButton: "btn fw-semibold btn-light-danger",
            },
          });
        }
      } catch (error) {
        Swal.fire({
          text: "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "ตกลง",
          customClass: {
            confirmButton: "btn fw-semibold btn-light-danger",
          },
        });
      }
    };

    return {
      footerWidthFluid,
      certNo,
      searchCertificate,
    };
  },
});
